import { __awaiter } from "tslib";
import stringify from 'json-stringify-pretty-compact';
import { parse as parseJSONC } from 'jsonc-parser';
import LZString from 'lz-string';
import * as React from 'react';
import Clipboard from 'react-clipboard.js';
import { Copy, Link, Save } from 'react-feather';
import { withRouter } from 'react-router-dom';
import { BACKEND_URL, COOKIE_NAME, NAMES } from '../../../constants/consts';
import getCookie from '../../../utils/getCookie';
import GistSelectWidget from '../../gist-select-widget';
import LoginConditional from '../../login-conditional';
import './index.css';
const EDITOR_BASE = window.location.origin + window.location.pathname;
class ShareModal extends React.PureComponent {
    constructor(props) {
        super(props);
        const date = new Date().toDateString();
        this.state = {
            copied: false,
            creating: undefined,
            createError: false,
            updateError: false,
            fullScreen: false,
            whitespace: false,
            generatedURL: '',
            gistFileName: 'spec.json',
            gistFileNameSelected: '',
            gistPrivate: false,
            gistTitle: `${NAMES[this.props.mode]} spec from ${date}`,
            gistId: '',
            updating: undefined,
            gistEditorURL: '',
        };
    }
    exportURL() {
        const specString = this.state.whitespace
            ? this.props.editorString
            : JSON.stringify(parseJSONC(this.props.editorString));
        const serializedSpec = LZString.compressToEncodedURIComponent(specString) + (this.state.fullScreen ? '/view' : '');
        if (serializedSpec) {
            const url = `${document.location.href.split('#')[0]}#/url/${this.props.mode}/${serializedSpec}`;
            this.setState({ generatedURL: url });
        }
    }
    previewURL() {
        const win = window.open(this.state.generatedURL, '_blank');
        win.focus();
    }
    onCopy() {
        if (!this.state.copied) {
            this.setState({
                copied: true,
            }, () => {
                setTimeout(() => {
                    this.setState({ copied: false });
                }, 2500);
            });
        }
    }
    handleFulscreenCheck(event) {
        this.setState({ fullScreen: event.target.checked }, () => {
            this.exportURL();
        });
    }
    handleWhitespaceCheck(event) {
        this.setState({ whitespace: event.target.checked }, () => {
            this.exportURL();
        });
    }
    componentDidMount() {
        this.exportURL();
    }
    updatePrivacy(event) {
        this.setState({
            gistPrivate: event.target.checked,
        });
    }
    fileNameChange(event) {
        this.setState({
            gistFileName: event.target.value,
        });
    }
    gistFileNameSelectedChange(event) {
        this.setState({
            gistFileNameSelected: event.target.value,
        });
    }
    titleChange(event) {
        this.setState({
            gistTitle: event.target.value,
        });
    }
    createGist() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({
                creating: true,
            });
            const body = {
                content: this.state.whitespace ? this.props.editorString : stringify(parseJSONC(this.props.editorString)),
                name: this.state.gistFileName || 'spec',
                title: this.state.gistTitle,
                privacy: this.state.gistPrivate,
            };
            const cookieValue = encodeURIComponent(getCookie(COOKIE_NAME));
            const res = yield fetch(`${BACKEND_URL}gists/create`, {
                body: JSON.stringify(body),
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    Cookie: `${COOKIE_NAME}=${cookieValue}`,
                },
                method: 'post',
            });
            const data = yield res.json();
            this.setState({
                creating: false,
                updating: undefined,
            }, () => {
                if (data.gistId === undefined) {
                    this.setState({
                        createError: true,
                    }, () => {
                        this.props.receiveCurrentUser(data.isAuthenticated);
                    });
                }
                else {
                    const { fileName, gistId } = data;
                    this.setState({
                        createError: false,
                        gistEditorURL: `${EDITOR_BASE}#/gist/${gistId}/${fileName}`,
                    });
                }
            });
        });
    }
    selectGist(id, fileName) {
        this.setState({
            gistFileNameSelected: fileName,
            gistId: id,
        });
    }
    updateGist() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({
                updating: true,
            });
            const fileName = this.state.gistFileNameSelected;
            if (this.state.gistId) {
                const cookieValue = encodeURIComponent(getCookie(COOKIE_NAME));
                const res = yield fetch(`${BACKEND_URL}gists/update`, {
                    body: JSON.stringify({
                        gistId: this.state.gistId,
                        fileName: fileName,
                        content: this.props.editorString,
                    }),
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        Cookie: `${COOKIE_NAME}=${cookieValue}`,
                    },
                    method: 'post',
                });
                const data = yield res.json();
                if (res.status === 205) {
                    const gistId = data.gistId;
                    const fileNameUpdated = data.fileName;
                    this.setState({
                        gistEditorURL: `${EDITOR_BASE}#/gist/${gistId}/${fileNameUpdated}`,
                        creating: undefined,
                        updating: false,
                        updateError: false,
                    });
                }
                else {
                    this.setState({
                        creating: undefined,
                        updating: false,
                        updateError: true,
                    });
                }
            }
        });
    }
    render() {
        return (React.createElement("div", { className: "share-modal" },
            React.createElement("h1", null, "Share"),
            React.createElement("h2", null, "Via URL"),
            React.createElement("p", null,
                "We pack the ",
                NAMES[this.props.mode],
                " specification as an encoded string in the URL. We use a LZ-based compression algorithm. When whitespaces are not preserved, the editor will automatically format the specification when it is loaded."),
            React.createElement("div", null,
                React.createElement("label", { className: "user-pref" },
                    React.createElement("input", { type: "checkbox", defaultChecked: this.state.fullScreen, name: "fullscreen", onChange: this.handleFulscreenCheck.bind(this) }),
                    "Open visualization in fullscreen"),
                React.createElement("label", { className: "user-pref" },
                    React.createElement("input", { type: "checkbox", defaultChecked: this.state.whitespace, name: "whitespace", onChange: this.handleWhitespaceCheck.bind(this) }),
                    "Preserve whitespace, comments, and trailing commas")),
            React.createElement("div", { className: "sharing-buttons" },
                React.createElement("button", { onClick: () => this.previewURL() },
                    React.createElement(Link, null),
                    React.createElement("span", null, "Open Link")),
                React.createElement(Clipboard, { className: "copy-icon", "data-clipboard-text": this.state.generatedURL, onSuccess: this.onCopy.bind(this) },
                    React.createElement(Copy, null),
                    React.createElement("span", null, "Copy Link to Clipboard")),
                React.createElement(Clipboard, { className: "copy-icon", "data-clipboard-text": `[Open the Chart in the Vega Editor](${this.state.generatedURL})`, onSuccess: this.onCopy.bind(this) },
                    React.createElement(Copy, null),
                    React.createElement("span", null, "Copy Markdown Link to Clipboard")),
                React.createElement("div", { className: `copied + ${this.state.copied ? ' visible' : ''}` }, "Copied!")),
            "Number of characters in the URL: ",
            this.state.generatedURL.length,
            ' ',
            React.createElement("span", { className: "url-warning" }, this.state.generatedURL.length > 2083 && (React.createElement(React.Fragment, null,
                "Warning:",
                ' ',
                React.createElement("a", { href: "https://support.microsoft.com/en-us/help/208427/maximum-url-length-is-2-083-characters-in-internet-explorer", target: "_blank", rel: "noopener noreferrer" }, "URLs over 2083 characters may not be supported in Internet Explorer.")))),
            React.createElement("div", { className: "spacer" }),
            React.createElement("h2", null,
                "Via",
                ' ',
                React.createElement("a", { href: "https://gist.github.com/", target: "_blank", rel: "noopener noreferrer" }, "GitHub Gist")),
            React.createElement(LoginConditional, null,
                React.createElement("p", null,
                    "Here, you can save your ",
                    NAMES[this.props.mode],
                    " specification as a new Gist or update an existing Gist. You can view all of your Gists on ",
                    React.createElement("a", { href: `https://gist.github.com/${this.props.handle}` }, "GitHub"),
                    "."),
                React.createElement("div", { className: "share-gist-split" },
                    React.createElement("div", { className: "update-gist" },
                        React.createElement("h3", null, "Update an existing Gist"),
                        React.createElement("p", null, "To update an existing Gist, select it in the list and then click the button below to confirm."),
                        React.createElement(GistSelectWidget, { selectGist: this.selectGist.bind(this) }),
                        this.props.isAuthenticated && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "share-input-container" },
                                React.createElement("label", null,
                                    "File name:",
                                    React.createElement("input", { value: this.state.gistFileNameSelected, onChange: this.gistFileNameSelectedChange.bind(this), type: "text" }),
                                    React.createElement("small", null, "Change the filename to create a new file in the selected Gist"))))),
                        React.createElement("div", { className: "sharing-buttons" },
                            React.createElement("button", { onClick: this.updateGist.bind(this), disabled: !this.state.gistFileNameSelected || this.state.updating },
                                React.createElement(Save, null),
                                this.state.updating ? 'Updating...' : 'Update'),
                            this.state.gistEditorURL && this.state.updating !== undefined && (React.createElement(Clipboard, { className: "copy-icon", "data-clipboard-text": this.state.gistEditorURL },
                                React.createElement(Copy, null),
                                React.createElement("span", null, "Copy Link to Clipboard")))),
                        this.state.updateError && React.createElement("div", { className: "error-message share-error" }, "Gist could not be updated.")),
                    React.createElement("div", null,
                        React.createElement("h3", null, "Create a new Gist"),
                        React.createElement("p", null,
                            "Save the current ",
                            NAMES[this.props.mode],
                            " specification as a Gist. When you save it, you will get a link that you can share. You can also load the specification via the Gist loading functionality in the editor."),
                        React.createElement("div", null,
                            React.createElement("label", { className: "user-pref" },
                                React.createElement("input", { type: "checkbox", defaultChecked: this.state.whitespace, name: "whitespace", onChange: this.handleWhitespaceCheck.bind(this) }),
                                "Preserve whitespace, comments, and trailing commas")),
                        React.createElement("div", { className: "share-input-container" },
                            React.createElement("label", null,
                                "Title:",
                                React.createElement("input", { value: this.state.gistTitle, onChange: this.titleChange.bind(this), type: "text", placeholder: "Enter title of gist" }))),
                        React.createElement("div", { className: "share-input-container" },
                            React.createElement("label", null,
                                "File name:",
                                React.createElement("input", { value: this.state.gistFileName, onChange: this.fileNameChange.bind(this), type: "text", placeholder: "Enter file name" }))),
                        React.createElement("div", { className: "share-input-container" },
                            React.createElement("label", null,
                                React.createElement("input", { type: "checkbox", name: "private-gist", id: "private-gist", value: "private-select", checked: this.state.gistPrivate, onChange: this.updatePrivacy.bind(this) }),
                                "Create a Private Gist")),
                        React.createElement("div", { className: "sharing-buttons" },
                            React.createElement("button", { onClick: this.createGist.bind(this), disabled: this.state.creating },
                                React.createElement(Save, null),
                                this.state.creating ? 'Creating...' : 'Create'),
                            this.state.gistEditorURL && this.state.creating !== undefined && (React.createElement(Clipboard, { className: "copy-icon", "data-clipboard-text": this.state.gistEditorURL },
                                React.createElement(Copy, null),
                                React.createElement("span", null, "Copy Link to Clipboard"))),
                            this.state.createError && React.createElement("div", { className: "error-message share-error" }, "Gist could not be created")))))));
    }
}
export default withRouter(ShareModal);
